// Import Theme Styles
import "../scss/style.scss";

// Import the new parallax script
import { initPromoBannerParallax } from "./partials/PageContent/promoBannerParallax";

const bootTheme = () => {
  console.log("[Client Theme] Initialized.");

  // Initialize the new parallax effect
  initPromoBannerParallax();
};

if (window.EcommerceCore) {
  bootTheme();
} else {
  window.addEventListener("ecommerce_core_ready", bootTheme);
}
